import React, { Component } from 'react'
import { COLUMNS } from './surveillanceTwoColumn'
import { TableTemplate } from '../../../hoc/tableSetting/TableTemplate'
import { TableTemplatePageWise } from '../../../hoc/tableSetting/TableTemplatePageWise'
import axios from 'axios'
import { APIURL } from '../../../hoc/AxiosSetting/axios'

export default  class surveillanceTwoList extends Component {
 
        constructor(props) {
            super(props)
            this.state = {
                usercode:props.match.params.usercode,
                isLoading: true,
                listqms:[

                ],
                orgCode: "",
                currentUserRole: "user",
            }
        }
        componentDidMount() {
          console.log("localStorage.getItem",localStorage.getItem("userCode"))
          // let APIURL = 'http://auditapi.gpiso.com'
            if (localStorage.getItem("userRole") === 'Admin')
                this.setState({ currentUserRole: "admin" })
              
                axios.get(APIURL + '/api/survillanceTwo/get/surveillancetwocompanylistbyrole/' + localStorage.getItem("userCode"))
               .then(res => {
                   console.log("res111", res.data.response)
                if (res.data.errorCode === 0) {
                    this.setState({ isLoading: false, listqms: res.data.response });
                } 
               console.log("listqms",res.data.response)
            })
            .catch(err => {
                // swal("Oops!", "Something went wrong", "error", err);
                //alert("something went wrong")
            })
        }
        render() {
          console.log("userrole",localStorage.getItem("role"))
           
              return (
                <div>
                  <div className="content-wrapper">
                    <section className="content-header">
                    </section>
                    <section className="content">
                      <div className="container-fluid">
                        <div className="row">
                          <div className="col-md-12">
                            <div className="card card-primary">
                              {/* <div className="card-header">
                                <h3 className="card-title">Audit Info List</h3>
                              </div> */}
                              <div className="card-body table-responsive">
                                <div className="row">
                                  <div className="col-sm-12">                              
                                    {
                                      this.state.listqms && this.state.listqms.length > 0 ?
                                      this.state.listqms.length <=  20?
                                      <TableTemplatePageWise userData={this.state.listqms} columns={COLUMNS}/>
                                       :
                                        <TableTemplate userData={this.state.listqms} columns={COLUMNS} />
                                        :
                                        <div>No Data Found</div>
                                    }
                                    
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </section>
                  </div>
                </div>
              
            )
    }
}

